import { FormBase } from "../../../../util/form-base-form";

class InstagramEmbedForm extends FormBase {
    public getEmbedScript(root: ParentNode = document): HTMLScriptElement | null {
        return this.queryElement(root, 'script[src="https://www.instagram.com/embed.js"]', HTMLScriptElement);
    }

    public getTileEmbedRoots(root: ParentNode = document): HTMLElement[] {
        return this.queryElements(root, ".sns-preview-tile--instagram .sns-embed.instagram-embed", HTMLElement);
    }

    public getRenderedIframe(root: ParentNode): HTMLIFrameElement | null {
        return this.queryElement(root, "iframe.instagram-media-rendered, iframe.instagram-media", HTMLIFrameElement);
    }
}

export const instagramEmbedForm = new InstagramEmbedForm();
